import React from 'react';
import { PowerIcon } from 'lucide-react';
import { useHoldToTrigger } from '../../hooks/useHoldToTrigger';
const C = 2 * Math.PI * 20;

/** Always-reachable emergency stop. Hold 2 s to trigger. */
export function NoodstopButton({
  onTrigger,
  size = 'sm'
}: {
  onTrigger: () => void;
  size?: 'sm' | 'wall';
}) {
  const {
    progress,
    handlers
  } = useHoldToTrigger(2000, onTrigger);
  const wall = size === 'wall';
  return <button type="button" {...handlers} aria-label="Noodstop. Houd 2 seconden vast." className={`inline-flex touch-none select-none items-center gap-3 whitespace-nowrap rounded-full border border-alarm/35 bg-alarm/[0.07] py-1.5 pl-1.5 text-alarm transition-colors duration-150 hover:bg-alarm/[0.12] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-alarm/60 ${wall ? 'pr-6' : 'pr-5'}`} data-id="element-1157" data-mp="xzatpssw88hn">
      <span className={`relative grid place-items-center ${wall ? 'h-14 w-14' : 'h-11 w-11'}`} data-id="element-1158" data-mp="2nf0h5yii2cxe">
        <svg className="absolute inset-0 -rotate-90" viewBox="0 0 44 44" aria-hidden data-id="element-1159" data-mp="2ncnzlmgnm4kv">
          <circle cx="22" cy="22" r="20" fill="none" stroke="currentColor" strokeOpacity="0.2" strokeWidth="2" data-id="element-1160" data-mp="2irmf8x7wuy06" />
          <circle cx="22" cy="22" r="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeDasharray={C} strokeDashoffset={C * (1 - progress)} data-id="element-1161" data-mp="2rm15futzbsy2" />
        </svg>
        <PowerIcon className={wall ? 'h-6 w-6' : 'h-5 w-5'} strokeWidth={2} aria-hidden data-id="element-1162" data-mp="1uvrxjm6w9ax4" />
      </span>
      <span className="flex flex-col items-start leading-tight" data-id="element-1163" data-mp="28vb2k64es657">
        <span className={`font-semibold text-ink ${wall ? 'text-[22px]' : 'text-[15px]'}`} data-id="element-1164" data-mp="28wug3oyok33a">Noodstop</span>
        <span className={`text-ink-muted ${wall ? 'text-[22px]' : 'text-[12px]'}`} data-id="element-1165" data-mp="23ykp7qjznonh">
          {progress > 0 ? 'Blijf vasthouden…' : 'Houd 2 s vast'}
        </span>
      </span>
    </button>;
}